// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"628":"964412e8","828":"b4020df2"}[chunkId] + ".chunk.css";
};